import './ui-status.css';
import './team-invite-ui';

declare const __APP_VERSION__: string;

const ANIMATED_FRAME_PREVIEW_WARNING =
  'Встроенный браузер Telegram не смог показать анимированную рамку на превью. Но в итоговом кружке рамка появится.';

function installVersionLabel(): void {
  if (document.getElementById('appVersionLabel')) {
    return;
  }
  const heroCopy = document.querySelector<HTMLElement>('.hero-copy');
  if (!heroCopy) {
    return;
  }
  const label = document.createElement('span');
  label.id = 'appVersionLabel';
  label.className = 'app-version-label';
  label.textContent = `Версия ${__APP_VERSION__}`;
  label.title = 'Текущая версия приложения';
  heroCopy.append(label);
}

function isAnimatedFramePreviewWarning(text: string): boolean {
  return (
    /\bMOV\b|анимирован/iu.test(text) &&
    /не воспроизвод|не смог|не поддерж|не отображ/iu.test(text)
  );
}

function installMovWarningTone(): void {
  const status = document.getElementById('brandPreviewStatus');
  if (!(status instanceof HTMLElement)) {
    return;
  }
  const sync = (): void => {
    const text = status.textContent?.trim() ?? '';
    const isWarning = isAnimatedFramePreviewWarning(text);
    if (isWarning && text !== ANIMATED_FRAME_PREVIEW_WARNING) {
      status.textContent = ANIMATED_FRAME_PREVIEW_WARNING;
    }
    status.classList.toggle('is-mov-warning', isWarning);
  };
  new MutationObserver(sync).observe(status, {
    childList: true,
    characterData: true,
    subtree: true,
  });
  sync();
}

function initializeUiStatus(): void {
  installVersionLabel();
  installMovWarningTone();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeUiStatus, { once: true });
} else {
  initializeUiStatus();
}
